import { useData } from "@/store/DataContext";
import { APP_NAME, LOGO_URL } from "@/lib/brand";
import Icon3D from "@/components/base/Icon3D";

export default function AppHeader() {
  const { data, updateSettings } = useData();
  const isDark = data.settings.theme === "dark";

  const toggleTheme = () => {
    updateSettings({ theme: isDark ? "light" : "dark" });
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-40 border-b border-background-200/70 bg-background-50/85 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-[480px] items-center justify-between px-5">
        <div className="flex items-center gap-2.5">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 shadow-card">
            <img src={LOGO_URL} alt={APP_NAME} className="h-full w-full object-contain p-1" />
          </div>
          <div className="leading-tight">
            <p
              className="text-[17px] text-foreground-950"
              style={{ fontFamily: '"Pacifico", serif' }}
            >
              {APP_NAME}
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={toggleTheme}
          aria-label="Cambiar tema"
          className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200/80 text-foreground-700"
        >
          <Icon3D icon={isDark ? "ri-sun-fill" : "ri-moon-fill"} tone={isDark ? "accent" : "secondary"} size={20} />
        </button>
      </div>
    </header>
  );
}